import { icons } from "utils/constants";
import {
  Button,
  CustomSuperfluidWidget,
  Modal,
  Roundedloader,
} from "components";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addTransactions,
  getSubscription,
  createNowPaymentInvoice,
  getSubscriptionOptions,
  // upadateNowPayment,
  getMySubscription,
  getDiscount,
  setIsDarkMode,
} from "store/globalSlice";
import { useNavigate, useParams } from "react-router-dom";

import "./SubscriptionPayment.scss";
import {
  decrypt,
  encrypt,
  generateOrderId,
  // storeLocalStorageData,
  titleCaseString,
} from "utils/helpers";
import { omit } from "lodash";
import { useAccount } from "wagmi";

const SubscriptionPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const account = useAccount();
  const { address } = account;
  const reduxData = useSelector((state) => state.global);
  const { paymentOptionList, isDarkMode } = reduxData || {};
  const { sub_tier_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [superFluidbtnLoading, setsuperFluidBtnLoading] = useState(false);
  const [subscriptionType, setsubscriptionType] = useState("");
  const [subscriptionStatus, setsubscriptionStatus] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [isOpenPopupSuper, setIsOpenPopupSuper] = useState(false);
  const [isDiv1Enabled, setIsDiv1Enabled] = useState(true);
  const [isDiv2Enabled, setIsDiv2Enabled] = useState(false);
  const [paymentInitialized, setPaymentInitialized] = useState(false);
  const [transactionLoading, setTransactionLoading] = useState(false);
  const [activeSubTierId, setActiveSubTierId] = useState("");
  const [countdown, setCountdown] = useState(10);

  const handleRadioChange = (event) => {
    const { value } = event.target;
    if (value === "superfluid") {
      setIsDiv1Enabled(true);
      setIsDiv2Enabled(false);
    } else if (value === "otherCrypto") {
      setIsDiv1Enabled(false);
      setIsDiv2Enabled(true);
    }
    setTimeout(() => {
      const divElement = document.querySelector(".radio-input").parentElement;
      divElement.classList.add("hidden");
    }, 10);
  };
  const handleSave = async () => {
    setIsOpenPopup(false);
    const currentUrl = window.location.href;
    setBtnLoading(true);
    let payload = {
      price_amount: selectedPlan.min_usd_per_month,
      price_currency: "usd",
      order_id: generateOrderId(),
      order_description: selectedPlan.description,
      ipn_callback_url: process.env.REACT_APP_NOW_PAYMENT_URL,
      success_url: currentUrl,
      cancel_url: currentUrl,
      partially_paid_url: `${currentUrl}?partially_paid=true`,
      is_fixed_rate: false,
      is_fee_paid_by_user: false,
      sub_tier_id: sub_tier_id,
    };
    const res = await dispatch(createNowPaymentInvoice(payload));
    if (res?.status === 201) {
      window.location.href = res?.data?.invoice_url;
    }
    setBtnLoading(false);
  };
  const storeLocalData = (data) => {
    let currentData = decrypt(localStorage.unTrnsDetails);
    localStorage.unTrnsDetails = encrypt({ ...currentData, ...data });
  };
  const getPaymentDetails = (amount) => {
    const returnValue = {
      modifyFlowRateBehaviour: "ADD",
      defaultWrapAmount: {
        multiplier: 1,
        period: "month",
      },
      paymentOptions: paymentOptionList?.map((o) => {
        return {
          ...o,
          flowRate: { amountEther: amount, period: "month" },
        };
      }),
    };
    return returnValue;
  };
  const fetchMySubscription = async () => {
    const res = await dispatch(getMySubscription());
    if (res?.status === 200) {
      setsubscriptionType(res?.data?.sub_type);
      setsubscriptionStatus(res?.data?.status);
      setActiveSubTierId(res?.data?.sub_tier_id);
    }
    const discountRes = await dispatch(getDiscount());
    if (discountRes?.status === 200) {
      setDiscountPercentage(discountRes?.data?.discount_percentage);
    }
  };
  const fetchSubscription = async () => {
    const res = await dispatch(getSubscription());
    let resData = res?.data || [];
    let selectedData = resData?.find((o) => o?.sub_tier_id === sub_tier_id);
    let selectedAmount = selectedData?.min_fund_per_month || 0;
    // if (discountPercentage) {
    //   const discount = (selectedAmount * (discountPercentage / 100));
    //   selectedAmount -= discount;
    // }
    let elemPaymentDetails = getPaymentDetails(`${selectedAmount.toFixed(2)}`);
    setPaymentDetails(elemPaymentDetails);
    setSelectedPlan(selectedData);
    setLoading(false);
  };
  const handleTransaction = async (payload) => {
    await dispatch(addTransactions(payload));
  };
  const fetchNowPaymentData = async () => {
    setBtnLoading(true);
    setTransactionLoading(true);
    setPaymentInitialized(true);
    // const NP_id = window.location.search.split("=").pop();
    // const UpdateNowPaymentResponse = await dispatch(
    //   upadateNowPayment(NP_id)
    // );
    // if (UpdateNowPaymentResponse?.status === 200) {
    //   if (UpdateNowPaymentResponse?.data?.payment_id) {
    //     storeLocalStorageData({ payment_id: UpdateNowPaymentResponse?.data?.payment_id })
    //     localStorage.NowPaymentDone = 1;
    //     navigate("/subscription-payment-success");
    //     setBtnLoading(false);
    //   } else if (UpdateNowPaymentResponse?.data?.message === "partially_paid") {
    //     navigate("/subscription-payment-success?partially_paid=true");
    //     setBtnLoading(false);
    //   }
    // } else if (UpdateNowPaymentResponse?.status === 400) {
    // navigate("/");
    setBtnLoading(false);
    // }
  };
  const handleAddSubscriptionAgain = () => {
    setIsOpenPopup(true);
  };

  useEffect(() => {
    if (localStorage.getItem("theme") === "dark") {
      dispatch(setIsDarkMode(true));
    } else {
      dispatch(setIsDarkMode(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    fetchMySubscription();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sub_tier_id]);
  useEffect(() => {
    if (paymentOptionList?.length > 0) {
      fetchSubscription();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentOptionList, discountPercentage]);
  useEffect(() => {
    let endValue = window.location?.search?.split("?")?.pop();
    if (endValue?.includes("NP_id")) {
      localStorage.NowPaymentDone = 1;
      fetchNowPaymentData();
    } else if (endValue?.includes("partially_paid")) {
      setPaymentInitialized(true);
      setTransactionLoading(true);
      // navigate(`/subscription-payment-success?partially_paid=true`);
    } else {
      dispatch(getSubscriptionOptions());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (paymentInitialized) {
        if (countdown > 0) {
          setCountdown((prevCountdown) => prevCountdown - 1);
        } else {
          setTransactionLoading(false);
          setPaymentInitialized(false);
          navigate("/");
        }
      }
    }, 1000);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentInitialized, countdown]);

  const eventListeners = {
    onPaymentOptionUpdate: (e) => {
      storeLocalData(
        omit(
          {
            ...e,
            ...e?.flowRate,
            ...e?.superToken,
          },
          ["flowRate", "superToken"]
        )
      );
    },
    onTransactionSent: (e) => {
      let newObj = {};
      let keyName = e.functionName;
      newObj[keyName] = e.hash;
      storeLocalData(newObj);
      if (["updateFlow"].includes(e.functionName)) {
        const { amountEther, chainId } =
          decrypt(localStorage.unTrnsDetails) || {};
        let payload = {
          hash: e.hash,
          // receiverAddress: "0x0eB2AB82e7F7A26C8EC6B6399910A7e935B484C5",
          receiverAddress:
            paymentOptionList[0]?.receiverAddress ||
            "0x42c1bbf9c3a2daaec18c78eb68847693d5279968",
          chainId: chainId,
          address: address,
          amountEther: amountEther,
          period: "month",
          function_name: e.functionName,
        };
        handleTransaction(payload);
      }
    },
    onSuccess: () => {
      setsuperFluidBtnLoading(true);
      setTimeout(() => {
        localStorage.NowPaymentDone = 1;
        navigate("/");
        setsuperFluidBtnLoading(false);
      }, 8000);
    },
  };
  const productDetails = {
    name: titleCaseString(selectedPlan?.name),
    description: selectedPlan?.description,
    image: selectedPlan?.image,
  };

  return (
    <div id="subscriptionpayment-container">
      <div className={`${isDarkMode ? "bb-4d6c" : "bb-e3e3"} cpt-22 cpb-22`}>
        <div className="fb-center container">
          <div className="h-35">
            <img
              src={isDarkMode ? icons.logoDark : icons.logo}
              alt="logo"
              className="fit-image"
            />
          </div>
        </div>
      </div>
      <div className="body-block container mt-5">
        {loading ? (
          <>
            <div
              className={`${
                isDarkMode ? "skeleton-dark" : "skeleton"
              } h-45 br-10 mb-3`}
            />
            <div className="row">
              <div className="col-md-8">
                <div
                  className={`${
                    isDarkMode ? "skeleton-dark" : "skeleton"
                  } h-200 br-10`}
                />
              </div>
              <div className="col-md-4">
                <div
                  className={`${
                    isDarkMode ? "skeleton-dark" : "skeleton"
                  } h-200 br-10`}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            {subscriptionStatus === "active" && isOpenPopup && (
              <Modal
                title="Subscription"
                width="620px"
                onHide={() => {
                  setIsOpenPopup(false);
                }}
                isDarkMode={isDarkMode}
              >
                <div className="cps-26 cpe-26 cpt-26 cmb-10">
                  <div className="h-175 cmb-26">
                    <img
                      src={
                        isDarkMode
                          ? icons.subscriptionsLight
                          : icons.subscriptions
                      }
                      alt="subscription"
                      className="fit-image"
                    />
                  </div>
                  <div
                    className={`text-center text-18-600 ${
                      isDarkMode ? "color-ffff" : "color-2749"
                    } cmb-10`}
                  >
                    Do you wish to continue?
                  </div>
                  <div
                    className={`text-center text-16-400 ${
                      isDarkMode ? "color-c9c9" : "color-7e91"
                    } cmb-26`}
                  >
                    A NowPayments subscription is already active! <br />
                    {activeSubTierId === sub_tier_id &&
                      "Renew your current subscription plan"}
                    {activeSubTierId !== sub_tier_id &&
                      "This will override the current subscription and start a new one!"}
                  </div>

                  <div className="f-center gap-3">
                    <Button
                      btnStyle="GD"
                      btnText="Cancel"
                      className="cps-45 cpe-45"
                      onClick={() => {
                        setIsOpenPopup(false);
                      }}
                    />
                    <Button
                      btnStyle="RD"
                      btnText="Add Again"
                      onClick={handleSave}
                      className="cps-40 cpe-40"
                    />
                  </div>
                </div>
              </Modal>
            )}
            {subscriptionStatus === "active" && isOpenPopupSuper && (
              <Modal
                title="Subscription"
                width="620px"
                onHide={() => {
                  setIsOpenPopupSuper(false);
                }}
                isDarkMode={isDarkMode}
              >
                <div className="cps-26 cpe-26 cpt-26 cmb-10">
                  <div className="h-175 cmb-26">
                    <img
                      src={
                        isDarkMode
                          ? icons.cancelSubscriptionLight
                          : icons.cancelSubscription
                      }
                      alt="subscription"
                      className="fit-image"
                    />
                  </div>
                  <div
                    className={`text-center text-18-600 ${
                      isDarkMode ? "color-ffff" : "color-2749"
                    } cmb-10`}
                  >
                    Oops! A SupeFluid subscription is already active! <br />
                    Close the current SuperFluid stream to start a new one.
                  </div>
                  <div
                    className={`text-center text-16-400 ${
                      isDarkMode ? "color-c9c9" : "color-7e91"
                    } cmb-26`}
                  >
                    Navigate to Superfluid dashboard under Transaction tab to
                    close stream.
                  </div>
                  <div className="f-center gap-3">
                    <Button
                      btnStyle="GD"
                      btnText="Return"
                      className="cps-45 cpe-45"
                      onClick={() => {
                        setIsOpenPopupSuper(false);
                      }}
                    />
                    <Button
                      btnStyle="RD"
                      btnText="Go to Transactions"
                      onClick={() => {
                        navigate("/transaction");
                      }}
                    />
                  </div>
                </div>
              </Modal>
            )}
            {paymentInitialized && (
              <Modal
                title="Payment Initializing"
                width="620px"
                onHide={() => {
                  // setIsOpenPopupSuper(false);
                }}
                isDarkMode={isDarkMode}
              >
                <div className="cps-26 cpe-26 cpt-26 cmb-10">
                  <div className="h-175 cmb-26">
                    <img
                      src={isDarkMode ? icons.paymentDark : icons.payment}
                      alt="Transaction"
                      className="fit-image"
                    />
                  </div>
                  <div
                    className={`text-center text-18-600 ${
                      isDarkMode ? "color-ffff" : "color-2749"
                    } cmb-10`}
                  >
                    Your transaction is being processed. <br />
                    Please wait...
                  </div>
                  <div className="f-center gap-3">
                    {/* <Button
                      btnStyle="GD"
                      btnText="Return"
                      className="cps-45 cpe-45"
                      onClick={() => {
                        setIsOpenPopupSuper(false);
                      }}
                    /> */}
                    <Button
                      btnStyle="MD"
                      btnText={`Redirecting in ${countdown}`}
                      onClick={() => {
                        // navigate("/transaction");
                      }}
                      loading={transactionLoading}
                    />
                  </div>
                </div>
              </Modal>
            )}
            <div className={`${isDarkMode ? "paymentBox-dark" : "paymentBox"}`}>
              <div className={`${isDarkMode ? "payment-dark" : ""}`}>
                <div
                  className={`text-26-600 ${
                    isDarkMode ? "color-ffff" : "color-2749"
                  } mb-3 cps-34`}
                >
                  Checkout
                </div>
                <div
                  className={`${
                    isDarkMode
                      ? "paymentMethod-darkOutline cms-34 brt-14 brb-14"
                      : "cps-34"
                  }`}
                >
                  <div
                    className={`brt-14 cp-10 ${isDarkMode ? "" : "b-dee3"} ${
                      isDarkMode ? "paymentMethod-dark" : ""
                    } brb-14`}
                  >
                    <div
                      className={`text-20-600 ${
                        isDarkMode ? "color-ffff" : "color-2749"
                      } mb-0 cps-20`}
                    >
                      Payment method
                    </div>
                  </div>
                </div>
                <div className="mt-3 d-flex align-items-center gap-3">
                  <div>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="superfluid"
                      checked={isDiv1Enabled}
                      onChange={handleRadioChange}
                      className="radio-input"
                      id="superfluidRadio"
                    />
                  </div>
                  <div
                    className={`brt-14 ${isDarkMode ? "" : "b-dee3"} ${
                      isDarkMode ? "superPayment-dark" : "cp-10"
                    } brb-14 body-block container ${
                      isDiv1Enabled
                        ? isDarkMode
                          ? "borderPaymentDark"
                          : "borderPayment"
                        : ""
                    }`}
                  >
                    <div
                      className={`${isDarkMode ? "superPayment-darkBox" : ""}`}
                    >
                      {paymentDetails && (
                        <CustomSuperfluidWidget
                          subscriptionType={subscriptionType}
                          sub_tier_id={sub_tier_id}
                          paymentDetails={paymentDetails}
                          eventListeners={eventListeners}
                          productDetails={productDetails}
                          loading={superFluidbtnLoading}
                          subscriptionStatus={subscriptionStatus}
                          setIsOpenPopupSuper={setIsOpenPopupSuper}
                          discountPercentage={discountPercentage}
                          isDiv1Enabled={isDiv1Enabled}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-3 d-flex align-items-center gap-3">
                  <div>
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="otherCrypto"
                      checked={isDiv2Enabled}
                      onChange={handleRadioChange}
                      className="radio-input"
                      id="otherCryptoRadio"
                    />
                  </div>
                  <div
                    className={`brt-14 ${isDarkMode ? "" : "b-dee3"} ${
                      isDarkMode ? "nowPayment-dark" : "cp-10"
                    } brb-14 body-block container ${
                      isDiv2Enabled
                        ? isDarkMode
                          ? "borderPaymentDark"
                          : "borderPayment"
                        : ""
                    }`}
                  >
                    <div
                      className={`${isDarkMode ? "nowPayment-darkBox" : ""}`}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="cmt-10">
                          <div className="d-flex">
                            <span className="w-30 h-30">
                              <img
                                src={icons.crypto}
                                alt="left-icon"
                                className="fit-image rounded-circle"
                              />
                            </span>
                            <div
                              className={`text-20-600 ${
                                isDarkMode ? "color-ffff" : "color-2749"
                              } mb-2 cps-10`}
                            >
                              Pay with other Crypto
                            </div>
                          </div>
                          <ul
                            className={`text-16-400 ${
                              isDarkMode ? "color-c9c9" : "color-7e91"
                            } cmb-0`}
                          >
                            <li>
                              Pay with Ethereum, Shib, or many other currencies
                            </li>
                          </ul>
                          <ul
                            className={`text-16-400 ${
                              isDarkMode ? "color-56ff" : "color-56ff"
                            }  pointer cms-2 mt-0`}
                            onClick={() => {
                              window.open(
                                "https://nowpayments.io/supported-coins",
                                "_blank"
                              );
                            }}
                          >
                            https://nowpayments.io/supported-coins
                          </ul>
                        </div>
                        <div
                          className={`button-container-superfluid cpe-14  ${
                            subscriptionType === "nowpayments" ||
                            subscriptionStatus !== "active"
                              ? ""
                              : "Inactive"
                          }`}
                        >
                          {isDiv2Enabled && (
                            <div
                              className={`btn-block fa-center pointer ${
                                isDiv2Enabled ? "fade-in-animation" : ""
                              }`}
                              onClick={
                                subscriptionStatus === "active"
                                  ? handleAddSubscriptionAgain
                                  : handleSave
                              }
                            >
                              <span className="d-flex align-items-center justify-content-center gap-2">
                                {/* {icons.nowPayment && (
                              <span className="h-20 d-flex">
                                <img src={icons.nowPayment} alt="left-icon" className="fit-image" />
                              </span>
                            )}
                            <span>NOWPayments</span> */}
                                <span className="text-18-500 color-ffff">
                                  Pay with other Crypto
                                </span>
                                {btnLoading && (
                                  <span>
                                    <Roundedloader type="D" />
                                  </span>
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubscriptionPayment;
